import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ORIGIN,
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    if (config.headers && typeof (config.headers as any).set === "function") {
      (config.headers as any).set("Authorization", `Bearer ${token}`);
    } else {
      config.headers = config.headers || {};
      (config.headers as any)["Authorization"] = `Bearer ${token}`;
    }
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => {
    const authHeader = response.headers?.authorization || response.headers?.Authorization;
    if (authHeader && typeof authHeader === "string" && authHeader.startsWith("Bearer ")) {
      const newToken = authHeader.replace("Bearer ", "").trim();
      if (newToken) {
        localStorage.setItem("token", newToken);
        axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${newToken}`;
      }
    }
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
